<template>
  <li v-if="post">
    <div class="post-body">
      <div class="image" v-if="post && post.social === 'FB'">
        <iframe
          v-if="post && post.hasVideo && post.attach && post.attach.length"
          :src="
            'https://www.facebook.com/plugins/video.php?href=' +
            post.attach[0].video_url +
            '&amp;width=500&amp;show_text=false&amp;appId=227160864129868&amp;height=281'
          "
          width="100%"
          height="auto"
          style="border: none; overflow: hidden"
          scrolling="no"
          frameborder="0"
          allowtransparency="true"
        ></iframe>

          <collage
            :items="imageAttach"
            :className="'paper-collage'"
            :padding="5"
            :tuid="randomHash"
            :befLoad="onBeforeLoad(post)"
            v-if="imageAttach.length >= 1"
          />
      </div>      
      <div class="image" v-if="post && post.social === 'VK'">
        <collage
          :items="imageAttach"
          :className="'paper-collage'"
          :padding="5"
          :tuid="randomHash"
          :befLoad="onBeforeLoad(post)"
          v-if="imageAttach.length >= 1"
        />

        <iframe v-if="videoAttach.length == 1" :src="`https://vk.ru/video_ext.php?oid=${videoAttach[0].owner_id}&id=${videoAttach[0].video_id}&hd=2`" width="853" height="480" allow="autoplay; encrypted-media; fullscreen; picture-in-picture;" frameborder="0" allowfullscreen></iframe>
      </div>
      <div class="image" v-if="post && post.social === 'IG'">
        <collage
          :items="allMediaAttach"
          :className="'paper-collage'"
          :padding="5"
          :tuid="randomHash"
          :befLoad="onBeforeLoad(post)"
          v-if="allMediaAttach.length >= 1"
        />
      </div>
      <div class="text" v-if="post">
        <a class="date" :href="post.link" target="_blank" v-if="post.link">
          {{ getTime }}
          <mod>{{ getDate }}</mod>
        </a>
        <p class="post-text">
          <span v-if="showText" v-html="showText"></span>
          <span
            class="more"
            v-if="post && post.textCanShowMore && post.post_id && !getPostTextShowMap[post.post_id]"
            @click="DASH_POST_SHOW_TEXT(post.post_id)"
            >{{ $t('POST_MORE') }}</span
          >
          <span
            class="more"
            v-if="post && post.textCanShowMore && post.post_id && getPostTextShowMap[post.post_id]"
            @click="DASH_POST_SHOW_TEXT(post.post_id)"
            >{{ $t('POST_LESS') }}</span
          >
        </p>
      </div>
    </div>
    
    <div class="m-tech" v-if="post && post.formatedStats">
      <div class="reactions" v-if="post.formatedStats.total">
        <div class="react-metric"
          :key="`${value}${post.local_id / 100}${post.page_id}${key}`"
          v-for="(value, key) in post.formatedStats.total"
        >
          <span>
            <i :class="`bi ${reactionIcons[key]}`"></i>
          </span>

          {{ value }}
        </div>
      </div>

      <div class="engagement" v-if="post.formatedStats.engagement">
        <div class="react-metric"
          :key="`${post.local_id}${value}${key}`"
          v-for="(value, key) in post.formatedStats.engagement"
        >
          <span>{{ $t("POSTS_FEED_" + key.toUpperCase()) }}</span>
          {{ value }}
        </div>
      </div>
    </div>
  </li>
  <li v-else class="post-error">
    <!-- Empty placeholder for invalid post -->
  </li>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import Collage from "./Collage";

import "glightbox/dist/css/glightbox.css";

import {
  DASH_UPDATE_ATTACHES,
  DASH_POST_SHOW_TEXT,
} from "@/store/actions/dash";

export default {
  name: "Dash-post-card",
  components: {
    Collage,
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    page: {
      type: Object,
      required: true,
    },
    post: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(["getPostTextShowMap"]),
    showText() {
      // Debug logging to identify problematic post
      if (!this.post || typeof this.post !== 'object') {
        return '';
      }
      
      let text = "";
      if (this.post.hasText) {
        if (
          this.post.textCanShowMore &&
          this.getPostTextShowMap[this.post.post_id]
        ) {
          text = this.post.text || "";
        } else if (
          this.post.textCanShowMore &&
          !this.getPostTextShowMap[this.post.post_id]
        ) {
          text = this.post.small_text || "";
        } else {
          text = this.post.text || "";
        }
      }

      // Only perform replacements if text is not empty
      if (text) {
        text = text.replace(/(https?:\/\/[^\s]+)/g, (match) => {
          return `<a class="link-hover" href="${match}" target="_blank">${match}</a>`;
        });

        text = text.replace(
          /\[([^\|\]]+)\|([^\]]+)\]/g,
          (match, id, label) => {
            return `<a class="link-hover" href="https://vk.com/${id}" target="_blank">${label}</a>`;
          }
        );
        
        text = text.replace(
          /(\s)@([A-Za-z0-9._]+)/g,
          (match, space, username) => {
            return `${space}<a class="link-hover" href="https://instagram.com/${username}" target="_blank">@${username}</a>`;
          }
        );
      }

      return text;
    },
    imageAttach() {
      return this.post?.attach?.filter((item) => item.type == "photo") || [];
    },
    videoAttach() {
      return this.post?.attach?.filter((item) => item.type == "video") || [];
    },
    allMediaAttach() {
      if (!this.post?.attach) return [];
      
      // For Instagram, combine photos and videos for collage display
      if (this.post.social === 'IG') {
        const mediaItems = this.post.attach.map(item => {
          // Convert reactive objects to plain objects
          const plainItem = JSON.parse(JSON.stringify(item));
          
          if (plainItem.type === 'video') {
            return {
              type: 'video',
              image_url: plainItem.video_url, // Use video URL as source for poster
              video_url: plainItem.video_url
            };
          }
          return {
            type: 'photo',
            image_url: plainItem.image_url
          };
        });
        
        // Remove duplicates based on image_url
        const uniqueItems = [];
        const seenUrls = new Set();
        
        for (const item of mediaItems) {
          if (item.image_url && !seenUrls.has(item.image_url)) {
            seenUrls.add(item.image_url);
            uniqueItems.push(item);
          }
        }
        
        return uniqueItems;
      }
      
      // For other social networks, return photos only (existing behavior)
      return this.imageAttach;
    },

    getTime() {
      if (!this.post || !this.post.date || !(this.post.date instanceof Date)) {
        return "";
      }
      return `${this.post.date.getHours()}:${
        (this.post.date.getMinutes() < 10 ? "0" : "") +
        this.post.date.getMinutes()
      }`;
    },
    getDate() {
      if (!this.post || !this.post.date || !(this.post.date instanceof Date)) {
        return "";
      }
      return this.moment(this.post.date).format("DD/MM/YYYY");
    },
    reactionIcons() {
      return {
        likes: "bi-heart",
        shares: "bi-arrow-return-left",
        comments: "bi-chat-right-dots",
        views: "bi-eye",
        er: "bi-heart",
        er_views: "bi-heart",
        ir: "bi-heart",
      };
    },
    randomHash() {
      return Math.random().toString(36).substr(2, 8);
    },
  },
  methods: {
    ...mapActions([DASH_UPDATE_ATTACHES]),
    ...mapMutations([DASH_POST_SHOW_TEXT]),
    async onError(event, post, attachNum) {
      if (!post) return;
      event.target.src = await this.DASH_UPDATE_ATTACHES({ post, attachNum });
    },

    onBeforeLoad: (post) => {
      if (!post) return () => {};
      return () => {
        // Implementation for loaded slides
      };
    }
  },
};
</script>

